import {Box, Stack} from "@mui/material";
import {getIconForLanguage, getNameForLanguage} from "crqlar-react-common/dist/utils/translations.util";
import React from "react";

/** A language by its own name ("Deutsch"), else its code. */
export const languageName = (code: string) => getNameForLanguage(code, false, true) || code.toUpperCase();

interface Props {
    code: string
}

/** Renders language flag icon and localized language name. */
const LanguageOption = ({code}: Props) => {
    const flag = getIconForLanguage(code);
    return (
        <Stack
            component={'span'}
            direction={'row'}
            alignItems={'center'}
            gap={1}
            sx={{minWidth: 0}}
        >
            {!!flag && (
                <Box
                    component={'img'}
                    src={flag}
                    alt={''}
                    // A code without a flag shows its name alone, never a broken image
                    onError={(event: React.SyntheticEvent<HTMLImageElement>) => { event.currentTarget.style.display = 'none'; }}
                    sx={{width: 18, height: 18, borderRadius: '50%', objectFit: 'cover', flexShrink: 0}}
                />
            )}
            <Box component={'span'} sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{languageName(code)}</Box>
        </Stack>
    );
};

export default LanguageOption;
